export default "__VITE_ASSET__BXE8DHUi__"